//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('operationLangs', {
//        templateUrl: 'views/components/views/operationLangs/operationLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'operationLangsService', function ($stateParams, stateService, operationLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let operationId = $stateParams.operation_id;

//            vm.model = {
//                inputListOperationLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListOperationLanguages = await operationLangsService.listOperationLanguages({ operation_id: operationId });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                operationLangsService.saveObj({ records: vm.model.inputListOperationLanguages }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//		    // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadLanguages();
//            }

//		    // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
